export default __webpack_public_path__ + "static/media/layaway.146cbf46.svg";